import { render, staticRenderFns } from "./CityList.vue?vue&type=template&id=cb15ece2&scoped=true"
import script from "./CityList.vue?vue&type=script&lang=js"
export * from "./CityList.vue?vue&type=script&lang=js"
import style0 from "./CityList.vue?vue&type=style&index=0&id=cb15ece2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb15ece2",
  null
  
)

export default component.exports